import React from 'react';
import { LogOut } from 'lucide-react';
import { ReactComponent as SharlyLogo } from '../../logo.svg';
import type { CurrentUser } from '../../types';

interface AppHeaderProps {
  currentUser: CurrentUser;
  universityName?: string;
  onLogout: () => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({ currentUser, universityName, onLogout }) => {
  const subtitle = currentUser.role === 'super_admin'
    ? 'System Administrator'
    : `University Administrator - ${universityName || 'Unknown'}`;

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-3">
            <SharlyLogo className="w-8 h-8 text-indigo-600" />
            <div>
              <h1 className="text-xl font-semibold text-gray-900">University Management</h1>
              <p className="text-sm text-gray-600">{subtitle}</p>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-600">{currentUser.email}</span>
            <button
              onClick={onLogout}
              className="flex items-center space-x-1 text-gray-600 hover:text-gray-900 transition-colors"
            >
              <LogOut className="w-4 h-4" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
